/* global axios */

// Minimal Vuex module for the Team Chat sidebar badge.
// Só expõe o total de não lidas do chat interno (salas internal_chat, a tela
// real do card "Chat interno" do Hub). Antes lia team_chat_conversations, o
// chat antigo sem tela, e o badge ficava sempre 0.

const accountIdFromPathname = () => {
  if (typeof window === 'undefined') return null;
  const parts = window.location.pathname.split('/');
  // expects /app/accounts/:accountId/...
  const idx = parts.indexOf('accounts');
  return idx >= 0 && parts[idx + 1] ? parts[idx + 1] : null;
};

const state = {
  unreadCount: 0,
  uiFlags: {
    isFetching: false,
  },
};

const types = {
  SET_UNREAD_COUNT: 'SET_TEAM_CHAT_UNREAD_COUNT',
  SET_FETCHING: 'SET_TEAM_CHAT_FETCHING',
};

const getters = {
  getUnreadCount($state) {
    return $state.unreadCount;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

const actions = {
  fetchUnreadCount: async ({ commit }) => {
    const accountId = accountIdFromPathname();
    if (!accountId) return;

    commit(types.SET_FETCHING, true);
    try {
      const { data } = await axios.get(
        `/api/v1/accounts/${accountId}/internal_chat/rooms/unread_count`
      );
      commit(types.SET_UNREAD_COUNT, Number(data?.count) || 0);
    } catch (e) {
      // Swallow — badge just stays stale on transient failures.
    } finally {
      commit(types.SET_FETCHING, false);
    }
  },

  setUnreadCount: ({ commit }, count) => {
    commit(types.SET_UNREAD_COUNT, Number(count) || 0);
  },
};

const mutations = {
  [types.SET_UNREAD_COUNT]($state, count) {
    $state.unreadCount = count;
  },
  [types.SET_FETCHING]($state, value) {
    $state.uiFlags.isFetching = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
